import React from 'react';
import { Modal, Input } from 'antd';

const BackupCodesModal = ({ isOpen, onClose, backupCodes }) => {
    return (
        <Modal
            title="Backup Codes"
            visible={isOpen}
            onCancel={onClose}
            footer={null}
        >
            <div className="row">
                {backupCodes.map((code, index) => (
                    <div className="col-md-6">
                        <Input className='m-2' key={index} value={code.code} disabled />
                    </div>
                ))}
            </div>
        </Modal>
    );
};

export default BackupCodesModal;